/**
 * Middle East & North Africa (MENA) countries.
 * Keep in sync with website/constants/countries.ts
 */
export const MENA_COUNTRIES = [
  { iso2: "EG", name: { en: "Egypt", ar: "مصر" }, dialCode: "20", flag: "🇪🇬" },
  {
    iso2: "SA",
    name: { en: "Saudi Arabia", ar: "السعودية" },
    dialCode: "966",
    flag: "🇸🇦",
  },
  {
    iso2: "AE",
    name: { en: "United Arab Emirates", ar: "الإمارات" },
    dialCode: "971",
    flag: "🇦🇪",
  },
  { iso2: "KW", name: { en: "Kuwait", ar: "الكويت" }, dialCode: "965", flag: "🇰🇼" },
  { iso2: "QA", name: { en: "Qatar", ar: "قطر" }, dialCode: "974", flag: "🇶🇦" },
  {
    iso2: "BH",
    name: { en: "Bahrain", ar: "البحرين" },
    dialCode: "973",
    flag: "🇧🇭",
  },
  { iso2: "OM", name: { en: "Oman", ar: "عُمان" }, dialCode: "968", flag: "🇴🇲" },
  { iso2: "JO", name: { en: "Jordan", ar: "الأردن" }, dialCode: "962", flag: "🇯🇴" },
  { iso2: "LB", name: { en: "Lebanon", ar: "لبنان" }, dialCode: "961", flag: "🇱🇧" },
  { iso2: "IQ", name: { en: "Iraq", ar: "العراق" }, dialCode: "964", flag: "🇮🇶" },
  { iso2: "SY", name: { en: "Syria", ar: "سوريا" }, dialCode: "963", flag: "🇸🇾" },
  { iso2: "YE", name: { en: "Yemen", ar: "اليمن" }, dialCode: "967", flag: "🇾🇪" },
  {
    iso2: "PS",
    name: { en: "Palestine", ar: "فلسطين" },
    dialCode: "970",
    flag: "🇵🇸",
  },
  {
    iso2: "DZ",
    name: { en: "Algeria", ar: "الجزائر" },
    dialCode: "213",
    flag: "🇩🇿",
  },
  { iso2: "MA", name: { en: "Morocco", ar: "المغرب" }, dialCode: "212", flag: "🇲🇦" },
  { iso2: "TN", name: { en: "Tunisia", ar: "تونس" }, dialCode: "216", flag: "🇹🇳" },
  { iso2: "LY", name: { en: "Libya", ar: "ليبيا" }, dialCode: "218", flag: "🇱🇾" },
  { iso2: "SD", name: { en: "Sudan", ar: "السودان" }, dialCode: "249", flag: "🇸🇩" },
  {
    iso2: "MR",
    name: { en: "Mauritania", ar: "موريتانيا" },
    dialCode: "222",
    flag: "🇲🇷",
  },
  { iso2: "TR", name: { en: "Turkey", ar: "تركيا" }, dialCode: "90", flag: "🇹🇷" },
];

export const DEFAULT_COUNTRY_ISO2 = "EG";

export const getCountryByIso2 = (iso2) =>
  MENA_COUNTRIES.find((c) => c.iso2 === String(iso2).toUpperCase());

export const getDefaultCountry = () => getCountryByIso2(DEFAULT_COUNTRY_ISO2);
